/** The two DOT values that name what a waste is. */
export type MaterialIdentity = {
  dotIdNumber?: string | null;
  dotProperShippingName?: string | null;
};

// Hazardous waste shipping names take a leading "Waste" (49 CFR 172.101(c)(9)),
// which a sheet may print or leave off without naming a different material.
const normalizedName = (name: string) =>
  name
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase()
    .replace(/^WASTE /, "");

const sameText = (a: string, b: string) => normalizedName(a) === normalizedName(b);

/**
 * Whether a profile sheet names a different material than the stream holds: its
 * UN number or shipping name differs from the stored one. A side that states
 * neither says nothing about the material either way, so it isn't a difference.
 */
export function describesOtherMaterial(
  sheet: MaterialIdentity | null | undefined,
  stored: MaterialIdentity | null | undefined
): boolean {
  const differs = (read: string | null | undefined, kept: string | null | undefined) =>
    !!read?.trim() && !!kept?.trim() && !sameText(read, kept);
  return (
    differs(sheet?.dotIdNumber?.replace(/\s/g, ""), stored?.dotIdNumber?.replace(/\s/g, "")) ||
    differs(sheet?.dotProperShippingName, stored?.dotProperShippingName)
  );
}
